import { handleActions, combineActions } from 'redux-actions';

import { CAPS_STATES } from '../constants';
import { getLoadingActions, getFinalizedActions } from '../utils/capabilities';

export default function createCapabilityReducer(CAPS) {
  const loadingActions = getLoadingActions(CAPS);
  const finalizedActions = getFinalizedActions(CAPS);

  const init = {
    states: {},
  };
  finalizedActions.forEach(key => {
    init.states[key] = CAPS_STATES.NOT_STARTED;
  });

  return handleActions(
    {
      [combineActions(...loadingActions)]: (state, { type, error }) => {
        if (error) {
          return state;
        }
        return {
          ...state,
          states: {
            ...state.states,
            [type.replace('/loading', '')]: CAPS_STATES.ONGOING,
          },
        };
      },
      [combineActions(...finalizedActions)]: (state, { type, error }) => {
        if (error) {
          return state;
        }
        return {
          ...state,
          states: {
            ...state.states,
            [type]: CAPS_STATES.FINISHED,
          },
        };
      },
    },
    init,
  );
}
